import { isReactNative } from 'yofobasement/utils/runtime';

let KeyBoard = {};

if (isReactNative()) {
  KeyBoard = require('react-native').Keyboard;
}

export default KeyBoard;



// WEBPACK FOOTER //
// ../biz-micro-services-ui/packages/basement/utils/Keyboard.js